import { useEffect, useMemo, useState } from "react";
import { TouchableOpacity, View, FlatList, Image, Text } from "react-native";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RankingType } from "./RankingComponents/types";
import { useDevice } from "../../../utils/hooks/useDevice";
import SvaraModal from "./SvaraModal";
import {
  BtnCloseModal,
  MessagesPng,
  ProfileRegistration,
  RankingTabBtn,
  RankingTabBtnSelected,
} from "../../../assets";
import { rankModalStyles } from "./RankingComponents/styles";
import Centered from "../../../shared/Centered";
import {
  selectMyTablesError,
  selectMyTablesItems,
  selectMyTablesLoading,
} from "../../../store/lobby/lobbySagas";
import { myTablesRequest } from "../../../store/lobby/lobbyActions";
import MyTablesComponent from "./MyTablesComponent";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";

type Nav = NativeStackNavigationProp<RootStackParamList>;
interface IProps {
  onClose: () => void;
}

function MyTablesModal({ onClose }: IProps) {
  const dispatch = useDispatch();
  const items = useSelector(selectMyTablesItems);
  const loading = useSelector(selectMyTablesLoading);
  const error = useSelector(selectMyTablesError);

  useEffect(() => {
    dispatch(myTablesRequest());
  }, [dispatch]);

  const { isMobile, height, width, isXs } = useDevice();
  const [rankingType, setRankingType] = useState(RankingType.Total);

  const { navigate } = useNavigation<Nav>();

  const { t } = useTranslation();

  const TAB_BAR_H = 40;
  const listH =
    height * 0.75 - (rankingType === RankingType.ChipsTotal ? TAB_BAR_H : 0);

  const handleOpenTable = (item: any) => {
    onClose();
    navigate("Game", {
      tableId: item.id,
      legacyRoomId: item.legacyRoomId,
      isTournamentRoom: !!item.isTournamentRoom,
    });
  };
  return (
    <SvaraModal
      visible
      onClose={onClose}
      closeIcon={BtnCloseModal}
      closeButtonSize="big"
      closeButtonStyles={{
        width: 42,
        height: 42,
        ...(isXs && { transform: [{ translateX: 11 }, { translateY: -10 }] }),
      }}
    >
      {/* Title */}
      <Text
        style={{
          color: "white",
          fontSize: 22,
          fontWeight: "700",
          textAlign: "center",
          marginBottom: 16,
          textTransform: "uppercase",
        }}
      >
        {t("T_SITE_ACTIVE_TABLES_TITLE")}
      </Text>

      {/* Header row */}
      <View
        style={{
          flexDirection: "row",
          paddingHorizontal: 16,
          marginBottom: 8,
          alignItems: "center",
          width: "92%",
        }}
      >
        <Text
          style={{
            flex: 1.5,
            color: "#ffffffdc",
            fontSize: 16,
            fontWeight: "700",
          }}
        >
          {t("T_SITE_ACTIVE_TABLES_TABLE")}
        </Text>
        <Text
          style={{
            flex: 1,
            color: "#ffffffdc",
            fontSize: 16,
            fontWeight: "700",
            textAlign: "left",
          }}
        >
          {t("T_SITE_ACTIVE_TABLES_CHIPS")}
        </Text>
        <Text
          style={{
            width: 90,

            color: "#ffffffdc",
            fontSize: 16,
            fontWeight: "700",
            textAlign: "center",
          }}
        >
          {t("T_SITE_ACTIVE_TABLES_NAVIGATE")}
        </Text>
      </View>

      <FlatList
        style={{
          height: listH,
          ...rankModalStyles.flatList,
        }}
        data={items}
        showsVerticalScrollIndicator={false}
        keyExtractor={(_, index) => index.toString()}
        renderItem={({ item, index }) => (
          <MyTablesComponent
            key={item.id}
            name={item.name}
            chips={Number(item.chips)}
            onOpen={() => handleOpenTable(item)}
          />
        )}
      />
    </SvaraModal>
  );
}

export default MyTablesModal;
